"use client";

import {Menu, MenuItem} from "../../../../../components/Menu";
import routes from "../../../../../utils/routes";
import {FrontWebRadioDetailModel} from "../../../../../generated";
import MenuModule from "./Menu.module.scss";

export const MenuRadio = (props: {radio: FrontWebRadioDetailModel, activeUrl: string}) => {

    const {
        activeUrl,
        radio: {
            hasPlaylist,
            hasDescription,
            hasSimilars,
            hasPodcasts,
            hasProgram,
            slug,
            linkColor
        }
    } = props;

    const items = [

    ] as MenuItem[];

    items.push({
        title: "Rychlé info",
        url: routes.radio_homepage(slug, {}, "homepage"),
        active: false,
        className: `${MenuModule.HomepageIcon} ms-4`,
    })

    if (linkColor) {
        items[0].className += " radioHomeColor";
    }


    if (hasPlaylist) {
        items.push({
            title: "Playlist",
            url: routes.radio_playlist(slug, {}, "playlist"),
            active: false,
        })
    }

    if (hasProgram) {
        items.push({
            title: "Program",
            url: routes.radio_songprogram(slug, {}, "program"),
            active: false,
        });
    }

    if (hasDescription) {
        items.push({
            title: "Info",
            url: routes.radio_info(slug, {}, "info"),
            active: false,
        });
    }

    if (hasPodcasts) {
        items.push({
            title: "Podcasty",
            url: routes.radio_program(slug, {}, "podcasty"),
            active: false,
        })
    }

    if (hasSimilars) {
        items.push({
            title: "Další stanice",
            url: routes.radio_podobnaradia(slug, {}, "podobna-radia"),
            active: false,
        });
    }

    let lengthCompare = 0;

    const compareAtiveUrl = activeUrl.replace(/(\?.*|#.*)$/g, "")
    const linkUrl = linkColor ?`${process.env.REACT_APP_API_DOMAIN}/generated/domecek/${linkColor.toUpperCase().replace("#", "")}.svg` : false;
    return (
        <div className={"mt-24px mb-24px"}>
            <Menu color={linkColor} items={items.map(item => {
                const inUrl = item.url.replace(/(\?.*|#.*)$/g, "");

                if (compareAtiveUrl.startsWith(inUrl)) {
                    if (lengthCompare < inUrl.length)
                        lengthCompare = inUrl.length
                    item.active = true;
                    if (item.className)
                    {
                        item.className +=  ` ${MenuModule.active}`
                    }
                }
                return item;
            }).map(item => {
                const inUrl = item.url.replace(/(\?.*|#.*)$/g, "");
                if (inUrl.length !== lengthCompare)
                {
                    if (item.active) {
                        item.active = false;
                        item.className = item.className?.replace(`${MenuModule.active}`, '');
                    }
                }
                return item;
            })}/>
            {linkUrl ? <style >{
                `a.radioHomeColor.active, a.radioHomeColor:hover {
                    background-image: url(${linkUrl});
                }`
            }</style> : null}
        </div>
    );
}